import React from 'react';
import { useGlobal } from 'reactn';

const Modal = (props) => {

  const [modalProps, setModalProps] = useGlobal('modalProps');

  const dismissModal = (e) => {
    resetModal();
  }

  const onClickOk = e => {
    setModalProps({ ...modalProps, showModal: false, messages: [] });
    if (modalProps.onOk) {
      modalProps.onOk(modalProps.onOkData || null);
    }
    resetModal();
  }

  const onClickCancel = e => {
    if (modalProps.onCancel) {
      modalProps.onCancel(null);
    }
    resetModal();
  }

  const resetModal = () => {
    setModalProps({
      showModal: false,
      showCancel: false,
      messages: [],
      size: ''
    });
  }

  if (!modalProps.showModal) return <></>;

  return (
    <div className={`confirmation-modal-container active ${modalProps.size ?? ''}`}>
      <div className="confirmation-wrapper">
        <div className="confirmation-modal-close" onClick={dismissModal}><i className="fa fa-times"></i></div>
        {modalProps.messages.map(msg => <div className="confirmation-message-item">
          {msg}
        </div>)}
        <div className="confirmation-modal-actions">
          {modalProps.isDeletion &&
            <>
              <button onClick={onClickOk} className="button-delete">
                {modalProps.okLabel || 'OK'}
              </button>
              <button onClick={onClickCancel} className="button-keep">
                {modalProps.cancelLabel || 'Cancel'}
              </button>
            </>}
          {!modalProps.isDeletion && <>
            <button onClick={onClickOk} className="button-ok">
              {modalProps.okLabel || 'OK'}
            </button>
            {modalProps.showCancel && <button onClick={onClickCancel} className="button-cancel">
              {modalProps.cancelLabel || 'Cancel'}
            </button>}            
          </>}
        </div>
      </div>
    </div>
  );
}

export default Modal;